@if (canShare && canDisplay) {
  <button appRipple data-test="share-button"
    class="share accent-background accent-contrast-color accent-contrast-border flex gap-[10px] justify-center items-center"
    (debounceClick)="share()">
    <cds-svg-icon [autofill]="false" name="share"></cds-svg-icon>
    <p>{{ 'send.share.share' | translate }}</p>
  </button>
}
